import { envConfig } from "../config";
import { HttpHelper, HttpServiceParams } from "rbh-merchant-core";
import { AUTH_REQUEST_ID_LIST } from "./auth-constant";
import { AuthToken, LoginData } from "./auth-type";
import axios, { AxiosResponse } from "axios";

class AuthServiceClass {
  private url = `${envConfig.hostname}`;
  postValidateEmail = async (params: HttpServiceParams) => {
    return await HttpHelper.post({
      url: this.url + "v1/merchant/company-admin/validation/email",
      data: params.data,
      id: AUTH_REQUEST_ID_LIST.POST_VALIDATION_EMAIL,
    });
  };

  forgotPassword = async (params: HttpServiceParams) => {
    return await HttpHelper.post({
      url: this.url + "v1/merchant/company-admin/forgot-password",
      data: params.data,
      id: AUTH_REQUEST_ID_LIST.FORGOT_PASSWORD,
    });
  };
  
  checkMailIsFirstLogin = async (params: HttpServiceParams) => {
    return await HttpHelper.post({
      url: this.url + "v1/merchant/company-admin/forgot-password/resend",
      data: params.data,
      id: AUTH_REQUEST_ID_LIST.IS_FIRST_LOGIN,
    });
  };

  login = async (params: HttpServiceParams<LoginData>) => {
    return await HttpHelper.post({
      url: this.url + "v1/merchant/company-admin/auth/signin",
      data: params.data,
      id: AUTH_REQUEST_ID_LIST.LOGIN,
    });
  };

  // NOTE: For first time login.
  setNewPassword = async (params: HttpServiceParams<LoginData>) => {
    return await HttpHelper.post({
      url: this.url + "v1/merchant/company-admin/auth/confirm-new-password",
      data: params.data,
      id: AUTH_REQUEST_ID_LIST.LOGIN,
    });
  };

  getCurrentSession = async (refreshToken: string) => {
    return axios.post<AxiosResponse<AuthToken>>(
      `${this.url}v1/merchant/company-admin/auth/refresh`,
      { refreshToken },
      {
        timeout: 3000,
        headers: {
          "request-id": AUTH_REQUEST_ID_LIST.GET_SESSION,
          "Access-Control-Allow-Origin": "*",
          "Cache-Control": "no-cache",
          "channel": "ADMIN_WEB",
        },
      }
    );
  };
}

export const AuthService = new AuthServiceClass();
